import { Component } from 'react'
import PropTypes from 'prop-types'
import messages from '@flix/common/domain/video/messages'
import { OverviewPlayerError } from '../../../pages/error/OverviewPlayerError'
import UnexpectedErrorPage from '../../../pages/error/UnexpectedErrorPage'
import bugsnag from '../../../services/bugsnag'

class VideoErrorBoundary extends Component {
  state = { hasError: false }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, shakaError) {
    this.notifyError(error, { shakaError })
  }

  handlePlayerError = (error, shakaError) => {
    this.notifyError(error, { shakaError })
    this.setState({ hasError: true })
  }

  notifyError = (error, errorDetails) => {
    if (process.env.NODE_ENV === 'development') {
      return console.log(error, this.props.metadata, errorDetails) // eslint-disable-line no-console
    }
    bugsnag.notify(error, (event) => {
      event.addMetadata('metadata', this.props.metadata)
      event.addMetadata('details', errorDetails)
    })
  }

  handlers = {
    onVideoError: this.handlePlayerError,
    notifyError: this.notifyError,
  }

  render() {
    const metaData = this.props.metadata
    if (this.state.hasError) {
      if (metaData?.film?.type === this.props?.contentType) {
        return <OverviewPlayerError />
      }
      return (
        this.props.fallback ?? (
          <UnexpectedErrorPage title={messages.videoErrorTitle} onBack={this.props.onBack} />
        )
      )
    }

    return this.props.children(this.handlers)
  }
}

VideoErrorBoundary.propTypes = {
  onBack: PropTypes.func,
  children: PropTypes.func.isRequired,
  fallback: PropTypes.any,
  metadata: PropTypes.object,
}

export default VideoErrorBoundary
